import React from 'react';

export default class LoadSudokuDropdown extends React.Component {

	constructor (props) {
		super(props);

		this.onLoad = this.onLoad.bind(this);
	}

	onLoad(event) {
		this.props.onChange(event.target.value);
	}

	render() {
		return (
			<div>
				<select id="selectSudokuString" onChange={this.onLoad} value={this.props.currentSudokuString}>
					<option value={LoadSudokuDropdown.CLEAR}>Load new sudoku ...</option>
					<option value={LoadSudokuDropdown.INITIAL}>Simple</option>
					<option value="030208070000109003280067001020003010700502006050806090500084067800701000040605020">Easy</option>
					<option value="200070038000006070300040600008020700100000006007030400004080009060400000910060002">Hidden Singles</option>
					<option value="006130500007009060300000000490005086000000000870900014000000007030800600008054200">Moderate</option>
					<option value="015000600300120000470008000002400080100000002080003400000700094000051007006000350">Hard</option>
					<option value="100306009000070200000005040200800406070000030805003001050700000003020000400901002">Very Hard</option>
					<option value="800000000003600000070090200050007000000045700000100030001000068008500010090000400">Arto Inkala</option>
					<option value="002800000030060007100000040600090000050600009000057060000300100070006008400000020">Unsolvable #49, sudokuwiki.org</option>
					<option value="600008940900006100070040000200610000000000200089002000000060005000000030800001600">World's hardest sudoku</option>
				</select>
			</div>
		);
	}
}
LoadSudokuDropdown.INITIAL = "207108309300629007060307050012000690500080001800090004021030780734805926980000013";
LoadSudokuDropdown.CLEAR =   "000000000000000000000000000000000000000000000000000000000000000000000000000000000";



// WEBPACK FOOTER //
// ./components/load-sudoku-dropdown.jsx